"use client";
import { useEffect, useCallback } from "react";

interface UseLanguageRefetchOptions {
  refetchFunction: () => Promise<void> | void;
  dependencies?: any[];
}

export const useLanguageRefetch = ({
  refetchFunction,
  dependencies = [],
}: UseLanguageRefetchOptions) => {
  const handleLanguageChange = useCallback(async () => {
    try {
      await refetchFunction();
    } catch (error) {
      console.error("Error refetching data after language change:", error);
    }
  }, [refetchFunction]);

  useEffect(() => {
    // Listen for language change events
    window.addEventListener("languageChanged", handleLanguageChange);

    return () => {
      window.removeEventListener("languageChanged", handleLanguageChange);
    };
  }, [handleLanguageChange]);

  // Also refetch when dependencies change
  useEffect(() => {
    refetchFunction();
  }, dependencies);
};
